import AWSPinpointProvider from './AWSPinpointProvider';
import AWSKinesisProvider from './AWSKinesisProvider';
import AmazonPersonalizeProvider from './AmazonPersonalizeProvider';

export { AWSPinpointProvider, AWSKinesisProvider, AmazonPersonalizeProvider };
